function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "25",
  viewBox: "0 0 28 25"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M28 21v4H0v-4h28zM13.284 0c.908 0 1.657.572 1.767 1.312l.014.188v11.267l2.925-2.352c.711-.572 1.839-.55 2.518.05.622.549.652 1.392.104 1.97l-.163.15-6.22 5c-.619.498-1.558.548-2.24.15l-.218-.15-6.22-5c-.711-.572-.737-1.521-.059-2.12.618-.545 1.605-.613 2.314-.191l.204.14 3.493 2.81V1.5c0-.828.798-1.5 1.781-1.5z"
}));